import React from 'react'

function BrandMark() {
  return (
      <img width={32} src="/logo192.png" alt="Entry Point logo"/>
  )
}

export default BrandMark